import service from "@/utils/service";

// 防伪码查询
export const validateApi = (params) => {
  return service({
    method: "POST",
    url: "/api/inner/client/product/archives/details",
    data: params,
  });
};
// 防伪码验证
export const verifyApi = (params) => {
  return service({
    method: "POST",
    url: "/api/inner/client/cert/validate",
    data: params,
  });
};
export const api_index_wx_share_get_weixin_share_info = (params) => {
  return service({
    url: "/api/inner/pay/wx/oauth/wx_scan_code_config",
    method: "POST",
    data: params,
  })
}

export const api_inner_pay_wx_oauth_user_info = (params) => {
  return service({
    url: "/api/inner/pay/wx/oauth/user_info",
    method: "POST",
    data: params,
  })
}

// 网站基本信息
export const web_base_config = params => {
  return service({
    method: "POST",
    url: "/api/inner/client/system/base_config",
    data: params
  });
};
